import { useQuery } from '@tanstack/react-query'
import { systemApi, engineApi, auditApi } from '../api/client'
import { StopEngineButton } from './StopEngineButton'
import './SafetyStrip.css'

export function SafetyStrip() {
  const health = useQuery({ queryKey: ['system-health'],
    queryFn: systemApi.getHealth, refetchInterval: 10000 })
  const engine = useQuery({ queryKey: ['engine-status'],
    queryFn: engineApi.getStatus, refetchInterval: 10000 })
  const autostop = useQuery({ queryKey: ['auto-stop-status'],
    queryFn: auditApi.autoStopStatus, refetchInterval: 10000 })
  const tripped = autostop.data?.available === true && autostop.data?.tripped === true
  // engineApi.getStatus() generic: { status: string, ... }
  const engineStatus = engine.data?.status ?? '—'
  // systemApi.getHealth() generic: { system_status: string, market_status: string, ... }
  const marketStatus = health.data?.market_status ?? '—'
  return (
    <div className={`safety-strip${tripped ? ' safety-strip--tripped' : ''}`}>
      <span className="safety-dot" data-ok={health.data?.system_status === 'running'} />
      <span className="safety-item">Engine: {engineStatus}</span>
      <span className="safety-item">Market: {marketStatus}</span>
      <span className="safety-item">
        Auto-stop: {autostop.data?.available
          ? (tripped ? 'TRIPPED' : 'armed') : 'unknown'}
      </span>
      <span className="safety-spacer" />
      <StopEngineButton />
    </div>
  )
}
